import { useEffect, useState } from "react";
import NocService from "./NocService";
import ModalComp from "../common/ModalComp";
import NocForm from "./NocForm";
import HistoryNoc from "./HistoryNoc";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, } from "react-bootstrap";
import "../style/style.css";
import ReactPaginate from "react-paginate";

const ApprovedList = () => {
    const [approvedListData, setApprovedListData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [applicationId, setApplicationId] = useState({});
    const [nocFormViewShow, setNocFormViewShow] = useState(false);
    const [nocFormModalShow, setNocFormModalShow] = useState(false);

    const nocFormModalShowClose = () => { setNocFormModalShow(false) }
    const nocFormViewShowClose = () => { setNocFormViewShow(false) }
    const pageSize = 20;
    const userId = sessionStorage.getItem("user");

    useEffect(() => {
        getData(userId, currentPage, pageSize);
    }, [currentPage]);

    const getData = (userId, pageNumber, pageSize) => {
        NocService.getApprovedList(userId, pageNumber, pageSize).then((result) => {
            setApprovedListData(result.content);
            setPageCount(result.totalPages);
        });
    };

    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        setCurrentPage(selectedPage);
    };
    const getApplication = (appId) => {
        setApplicationId(appId);
        setNocFormModalShow(true);
    }

    const callBack = (appId) => {
        getData();
        setNocFormViewShow(false);
    }
    const viewApplication = (appId) => {
        setNocFormViewShow(true)
        setApplicationId(appId);
    }

    return (
        <main id="main" className="main">
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Approved List</h5>
                                <div className="row g-12">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Application No</th>
                                                <th>Name Of Employee</th>
                                                <th>Passport No</th>
                                                <th>Designation</th>
                                                <th>Department</th>
                                                {/* <th>Mobile No</th> */}
                                                <th>View Application</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {approvedListData && approvedListData.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row.applicationNumber}</td>
                                                    <td>{row.name}</td>
                                                    <td>{row.passportNumber}</td>
                                                    <td>{row.designation}</td>
                                                    <td>{row.department}</td>
                                                    {/* <td>{row.mobileNumber}</td> */}
                                                    <td><button type="button" onClick={() => { viewApplication(row) }} className="btn btn-success view-btn">View</button></td>
                                                    <td><a href="#" onClick={() => { getApplication(row.applicationId) }}> {row.description} </a></td>
                                                    {/* <td style={{ cursor: "pointer" }} onClick={() => getApplication(row.applicationId)}>
                                                        {row.description}
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <ReactPaginate
                                        previousLabel={"Previous"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />

                                    <ModalComp
                                        size={"lg"}
                                        show={nocFormViewShow}
                                        handleClose={nocFormViewShowClose}
                                        modalTitle={"Proforma particulars to be furnished for Issue of NOC"}
                                        modalBody={<NocForm application={applicationId} blockUploads={true} callBack={callBack} ></NocForm>}
                                    />

                                    <ModalComp
                                        size={"lg"}
                                        show={nocFormModalShow}
                                        handleClose={nocFormModalShowClose}
                                        modalTitle={"History"}
                                        modalBody={<HistoryNoc nocId={applicationId}></HistoryNoc>}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default ApprovedList;
